<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner whole">
        <div class="modal">
          <header class="header ${glassClass} ${primaryClass}">
            <div class="inner">
              <h1 class="ttl">축하 화환</h1>
              <div class="right">
                <button class="header-btn" @click="close"><i class="ico-close-gray90"></i></button>
              </div>
            </div>
          </header>
          <div class="modal-con pd0">
            <iframe :src="url" class="site" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps } from 'vue';
import { CODE_ENV_LIST } from '@/common/constants/ConstCode';

const props = defineProps(['data']);
const emits = defineEmits(['close']);

const { url } = props.data;

const close = () => {
  setTimeout(() => {
    emits('close');
  }, 200);
};
</script>

<style scoped></style>
